import React, { useRef, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TextField, IconButton, Tooltip, InputAdornment, Modal, Box, Grid, Typography, FormControl, InputLabel, Select, MenuItem, Divider } from "@mui/material";
import { Close, Delete, Edit } from "@mui/icons-material"
import { useDispatch, useSelector } from "react-redux";
import { selectChapterSharePayload, selectChapterShareReport, setChapterShareReportDetails } from "../app/features/chapterReportSlice";
import { Controller, useForm } from "react-hook-form";
import { useDeletePayChaterShareMutation, useGetMonitorChapterShareMutation, useUpdatePayChaterShareMutation } from "../app/services/chapterServices";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { notoSansRegular } from "../Component/roboto";

const style1 = {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 1000,
    minWidth: 300,
    height: '60%',
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: 4,
    overflowY: 'scroll',
    "&::-webkit-scrollbar": {
        display: 'none'
    },
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 500,
    minWidth: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

const ChapterFinancialReport = () => {
    const financialData = useSelector(selectChapterShareReport)
    const chapterSharepayload = useSelector(selectChapterSharePayload)
    const chapterName = financialData?.chapterDetails?.chapterName || 'chapter name'
    const card1Ref = useRef(null);
    const [loading, setLoading] = useState(false)
    const [updateChapterPay] = useUpdatePayChaterShareMutation()
    const [deletePay] = useDeletePayChaterShareMutation()
    const [chaptermonitor] = useGetMonitorChapterShareMutation()
    const dispatch = useDispatch()
    const [selectedPaymentId, setSelecedPaymentId] = useState(null);
    const [openForm, setOpenForm] = useState(false)
    const [open, setOpen] = useState(false)

    const {
        control: controlPay,
        register: registerPay,
        setError: setErrorPay,
        handleSubmit: handleSubmitPay,
        watch: watchPay,
        reset: resetPay,
        clearErrors: clearErrorPay,
        formState: { errors: errorsPay },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            amount: '',
            paymentDate: '',
            balance: '',
            payType: '', //0 - credit,1 - debit
            description: ''
        },
    });

    const handleFormClose = () => {
        setOpenForm(false)
        resetPay({})
        setSelecedPaymentId(null)
    }

    const handleOpenForm = (payment, balance) => {
        setSelecedPaymentId(payment?._id)
        resetPay({
            amount: payment?.amount.split('₹')[1],
            paymentDate: payment?.paymentDate
                ? new Date(payment.paymentDate).toISOString().split("T")[0]
                : '',
            payType: payment?.payType,
            description: payment?.description,
            balance: balance
        })
        setOpenForm(true);
    }

    const handleOpenDelete = (payment) => {
        setSelecedPaymentId(payment?._id)
        setOpen(true)
    }

    const handleDeleteClose = () => {
        setSelecedPaymentId(null)
        setOpen(false)
    }

    // Export Chapter Share as PDF Format using JSPDF Package
    const exportToPDF = () => {
        setLoading(true);

        const doc = new jsPDF({
            orientation: "p",
            unit: "mm",
            format: "a4",
            putOnlyUsedFonts: true,
            encoding: "UTF-8",
        });

        // --- Add font --- (Change font because rupee symbol is not accepted)
        doc.addFileToVFS("NotoSans-Regular.ttf", notoSansRegular);
        doc.addFont("NotoSans-Regular.ttf", "NotoSans", "normal");
        doc.setFont("NotoSans", "normal");

        autoTable(doc, {
            html: "#head-table",
            theme: "striped",
            styles: {
                font: "NotoSans",
                fontSize: 8,
                cellPadding: { top: 4, bottom: 4, left: 2, right: 2 }, // extra padding
                lineWidth: 0.1,
                halign: "left",
                lineHeight: 1.5
            },
            headStyles: {
                fillColor: [112, 33, 33],
                textColor: [255, 255, 255],
                fontSize: 11,
                fontStyle: "bold",
                halign: "center",
            },
            columnStyles: {
                0: { cellWidth: 60 },
                1: { cellWidth: 140 },
            },
            bodyStyles: {
                textColor: [50, 50, 50],
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            margin: { top: 10, left: 5, right: 5 },
        });
        autoTable(doc, {
            html: "#content-table",
            theme: "striped",
            styles: {
                font: "NotoSans",
                fontSize: 8,
                cellPadding: { top: 4, bottom: 4, left: 2, right: 2 }, // extra padding
                valign: "middle",
                lineWidth: 0.1,
                halign: "left",
                lineHeight: 1.5
            },
            headStyles: {
                fillColor: [112, 33, 33],
                textColor: [255, 255, 255],
                fontSize: 8,
                fontStyle: "bold",
                halign: "left",
            },
            columnStyles: {
                0: { cellWidth: 21, halign: "left" }, // "Month & Year"
                1: { cellWidth: 20, halign: "left" }, // "Membership Type"
                2: { cellWidth: 19, halign: "left" }, // "Membership Plan"
                3: { cellWidth: 12, halign: "left" }, // "New"
                4: { cellWidth: 12, halign: "left" }, // "Renewal"
                5: { cellWidth: 20, halign: "left" }, // "15% Share"
                6: { cellWidth: 19, halign: "left" }, // "Credit"
                7: { cellWidth: 18, halign: "left" }, // "Debit"
                8: { cellWidth: 18, halign: "left" }, // "Balance"
            },
            bodyStyles: {
                textColor: [50, 50, 50],
            },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            margin: { top: 10, left: 5, right: 5 },
        });

        doc.save(`${chapterName}-share-report.pdf`);
        setTimeout(() => setLoading(false), 1000);
    };

    const updatePayChapter = (formData) => {
        const payload = { id: selectedPaymentId, payData: { ...formData, balance: formData.balance.split('₹')[1] } }
        updateChapterPay(payload).then((res) => {
            setLoading(false)
            if (res?.data?.status) {
                handleFormClose();
                toast.success(res?.data?.message)
                chaptermonitor(chapterSharepayload).then((res) => {
                    if (res?.data?.data) {
                        dispatch(setChapterShareReportDetails(res?.data?.data));
                    }
                    else {
                        toast.error(res?.data?.err?.message)
                    }
                }).catch(() => setLoading(false))
            }
        })
    }

    const deletePayChapter = () => {
        deletePay(selectedPaymentId).then(res => {
            if (res?.data?.status) {
                handleDeleteClose()
                toast.error(res?.data?.message)
                chaptermonitor(chapterSharepayload).then((res) => {
                    setLoading(false)
                    if (res?.data?.data) {
                        dispatch(setChapterShareReportDetails(res?.data?.data));
                    }
                    else {
                        toast.error(res?.data?.err?.message)
                    }
                }).catch(() => setLoading(false))
            }
        })
    }

    return (
        <>
            <div className="pt-5 d-print-none">
                <div className="chapter-heading ">
                    <h2 className="text-center title-font text-light py-3 mt-1">Financial Report of Chapter&apos;s Share</h2>
                </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
                <div className='text-end mb-3 d-print-none'>
                    <Button onClick={() => window.history.back()} variant="contained" className='menus-color'
                    >Back</Button>
                </div>
                <div ref={card1Ref}>
                    <TableContainer component={Paper} className="shadow-none">
                        <Table id="head-table">
                            <TableHead sx={{ bgcolor: 'secondary.main' }}>
                                <TableRow sx={{ bgcolor: 'secondary.main' }}>
                                    <TableCell align="center" colSpan={2} className="border text-white">Financial Report of Chapter’s Share</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className="border">Name of the Chapter</TableCell>
                                    <TableCell className="border">{chapterName}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="border">Report for the period</TableCell>
                                    <TableCell className="border">From {new Date(financialData?.chapterDetails?.fromDate.split('-')[1], Number(financialData?.chapterDetails?.fromDate.split('-')[0] - 1), 1).toLocaleString('en-GB', {
                                        month: 'short', year: 'numeric'
                                    })} To {new Date(financialData?.chapterDetails?.toDate.split('-')[1], Number(financialData?.chapterDetails?.toDate.split('-')[0] - 1), 1).toLocaleString('en-GB', {
                                        month: 'short', year: 'numeric'
                                    })}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TableContainer component={Paper} className="shadow-none">
                        <Table id="content-table">
                            <TableHead sx={{ bgcolor: 'secondary.main' }}>
                                <TableRow>
                                    <TableCell className="border text-white" width={'5%'}>Month & Year</TableCell>
                                    <TableCell className="border text-white" width={'10%'}>Membership Type</TableCell>
                                    <TableCell className="border text-white" width={'10%'}>Membership Plan</TableCell>
                                    <TableCell className="border text-white" colSpan={2} width={'10%'}>New</TableCell>
                                    <TableCell className="border text-white" colSpan={2} width={'10%'}>Renewal</TableCell>
                                    <TableCell className="border text-white" width={'10%'}>15% Share</TableCell>
                                    <TableCell className="border text-white" width={'15%'}>Credit</TableCell>
                                    <TableCell className="border text-white" width={'10%'}>Debit</TableCell>
                                    <TableCell className="border text-white" width={600}>Balance</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {financialData?.financialReport?.map((report, reportIndex) => {
                                    const totalPlans = report?.entries?.reduce(
                                        (acc, item) => acc + (item?.planTypes?.length || 0),
                                        0
                                    ) + report?.paymentEntries.length
                                    return (
                                        <React.Fragment key={reportIndex}>
                                            {report?.entries?.length > 0 ? (
                                                report.entries.map((entry, entryIndex) =>
                                                    entry.planTypes.map((plan, planIndex) => (
                                                        <TableRow key={`${entryIndex}-${planIndex}`}>
                                                            {/* Month column */}
                                                            {planIndex === 0 && entryIndex === 0 && (
                                                                <TableCell className="border" rowSpan={totalPlans}>
                                                                    {`${report?.month} ${report?.fromYear}`}
                                                                </TableCell>
                                                            )}
                                                            {/* Membership type */}
                                                            {planIndex === 0 && (
                                                                <TableCell className="border" rowSpan={entry.planTypes.length}>
                                                                    {entry?.membershipType}
                                                                </TableCell>
                                                            )}

                                                            {/* Plan details */}
                                                            <TableCell className="border">{plan?.membershipPlan}</TableCell>
                                                            <TableCell className="border">{plan?.newCount}</TableCell>
                                                            <TableCell className="border">{plan?.amount}</TableCell>
                                                            <TableCell className="border">{plan?.renewalCount}</TableCell>
                                                            <TableCell className="border">{plan?.renewalAmount}</TableCell>
                                                            <TableCell className="border">{plan?.sharePercent}</TableCell>

                                                            {/* Credit / Debit / Balance only once per report */}
                                                            {planIndex === 0 && entryIndex === 0 && (
                                                                <>
                                                                    <TableCell className="border" rowSpan={totalPlans - report?.paymentEntries.length}>
                                                                        {report?.credit || "-"}
                                                                    </TableCell>
                                                                    <TableCell className="border" rowSpan={totalPlans - report?.paymentEntries.length}>
                                                                        {report?.debit || "-"}
                                                                    </TableCell>
                                                                    <TableCell className="border" rowSpan={totalPlans - report?.paymentEntries.length}>
                                                                        {reportIndex === 0 ? report?.balance : report?.entriesBalance || "-"}
                                                                    </TableCell>
                                                                </>
                                                            )}
                                                        </TableRow>
                                                    ))
                                                )
                                            ) : (
                                                <TableRow>
                                                    <TableCell className="border" colSpan={reportIndex === 0 ? 8 : 0} rowSpan={totalPlans + 1}>
                                                        {`${report?.month} ${report?.fromYear}`}
                                                    </TableCell>
                                                    {reportIndex !== 0 && <TableCell className="border  " align="center" colSpan={7}>
                                                        No Entries
                                                    </TableCell>}
                                                    <TableCell className="border">{report?.credit || "-----"}</TableCell>
                                                    <TableCell className="border">{report?.debit || "-----"}</TableCell>
                                                    <TableCell className="border">{(reportIndex === 0 || report?.paymentEntries.length <= 0) ? report?.balance : report?.entriesBalance || "-----"}</TableCell>
                                                </TableRow>
                                            )}
                                            {/* Payment Entries */}
                                            {report?.paymentEntries?.length > 0 &&
                                                report.paymentEntries.map((payEntry, idx) => {
                                                    return (
                                                        <TableRow key={`payment-${idx}`}>
                                                            {/* {idx === 0 && <TableCell rowSpan={totalPlans} className="border">
                                                                {`${report?.month} ${report?.fromYear}`}
                                                            </TableCell>} */}
                                                            <TableCell className="border" colSpan={7}>

                                                                {payEntry?.description}
                                                            </TableCell>

                                                            {payEntry?.payType === 0 || payEntry?.payType === "0" ? (
                                                                <>
                                                                    <TableCell className="border">{payEntry?.amount}
                                                                    </TableCell>
                                                                    <TableCell className="border">-----</TableCell>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <TableCell className="border">-----</TableCell>
                                                                    <TableCell className="border">
                                                                        {payEntry?.amount}
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            <TableCell className="border">
                                                                <div className="d-flex justify-content-between w-100 align-items-center">
                                                                    <span>{payEntry?.balance}</span>
                                                                    <span className="no-print" style={{ width: 75 }}>
                                                                        <Tooltip title='Edit'><IconButton onClick={() => { handleOpenForm(payEntry, report?.paymentEntries[idx - 1] ? report?.paymentEntries[idx - 1]?.balance : financialData?.financialReport[reportIndex]?.entriesBalance); }}><Edit color="success" fontSize="small" /></IconButton></Tooltip>
                                                                        <Tooltip title='Delete'><IconButton onClick={() => handleOpenDelete(payEntry)}><Delete className="text-danger" fontSize="small" /></IconButton></Tooltip>
                                                                    </span>
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="text-center mt-3"><Button onClick={exportToPDF} variant="contained" disabled={loading} className="rounded-0 d-print-none" color="primary">{loading ? 'Generating PDF...' : 'Download as PDF'}</Button></div>
            </div>
            <Modal
                open={open}
                onClose={handleDeleteClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box
                    sx={style}
                    className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                            Confirmation
                        </Typography>
                        <IconButton onClick={handleDeleteClose} aria-label="Close">
                            <Close />
                        </IconButton>
                    </div>
                    <Box display="flex" justifyContent="center" width="100%">
                        <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                    </Box>
                    <Typography
                        id="modal-modal-title"
                        style={{ color: "#611f1e" }}
                        variant="h6"
                        component="h2"
                        className="content-font">
                        Are You Surely Want to Delete this payment entry?
                    </Typography>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            variant="outlined"
                            className="content-font"
                            style={{

                                color: "#dc3545",
                                border: "1px solid #dc3545",
                                padding: "5px 15px",
                                borderRadius: "0px",
                            }}
                            onClick={handleDeleteClose}>
                            No
                        </Button>
                        <Button
                            className="mx-2 content-font"
                            variant="contained"
                            style={{
                                backgroundColor: "#2e7d32",
                                color: "white",
                                padding: "5px 15px",
                                borderRadius: "0px",
                            }}
                            onClick={() => deletePayChapter()}>
                            Yes
                        </Button>
                    </div>
                </Box>
            </Modal>
            <Modal
                open={openForm}
                onClose={handleFormClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style1} className="d-flex w-100 align-items-center flex-column gap-3">
                    <h4 className="alata-regular fs-3 title-font" style={{ color: "#104e29" }}>Pay chapter</h4>
                    <form className="w-100 d-flex flex-column justify-content-between h-100" onSubmit={handleSubmitPay(updatePayChapter)}>
                        <Grid container rowSpacing={2} columnSpacing={3}>
                            <Grid item xs={12} md={6} lg={4}>
                                <Controller
                                    control={controlPay}
                                    name="payType"
                                    rules={{
                                        required: "Please select a option",
                                    }} // Validation rule
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth error={!!fieldState.error} disabled>
                                            <InputLabel id="toMonth-label" className="text-dark">
                                                Credit / Debit <span style={{ color: "red" }}>*</span>
                                            </InputLabel>
                                            <Select
                                                {...field} // Properly bind field props
                                                labelId="toMonth-label"
                                                displayEmpty
                                                label={
                                                    <Typography className="text-dark">
                                                        Credit / Debit
                                                        <span style={{ color: "red" }}>*</span>
                                                    </Typography>
                                                } value={field.value || ""} // Ensure value is controlled
                                                onChange={(e) => {
                                                    field.onChange(e.target.value);
                                                    if (e.target.value.toString() === '1' && watchPay('balance') && watchPay('amount') && Number(watchPay("balance").split("₹")[1]) < Number(watchPay('amount'))) {
                                                        setErrorPay('amount', { type: 'manual', message: `Please enter an amount less than the available balance (${watchPay("balance")})` })
                                                    }
                                                    else {
                                                        clearErrorPay('amount')
                                                    }
                                                }}>
                                                <MenuItem value={'0'}>Credit</MenuItem>
                                                <MenuItem value={'1'}>Debit</MenuItem>
                                            </Select>
                                            {fieldState.error && (
                                                <Typography variant="caption" className="fw-light ps-2" color="error">
                                                    {fieldState.error.message}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    id="startDate"
                                    label={
                                        <Typography className="text-dark">
                                            Payment Date <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                    }
                                    inputProps={{
                                        max: (() => {
                                            const d = new Date();
                                            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
                                                d.getDate()
                                            ).padStart(2, "0")}`;
                                        })(),
                                        min: (() => {
                                            const d = new Date(2025, 0, 1);
                                            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
                                                d.getDate()
                                            ).padStart(2, "0")}`;
                                        })(),
                                    }}
                                    variant="outlined"
                                    type="date"
                                    {...registerPay("paymentDate", {
                                        required: "Please select a date",
                                        max: { value: new Date().toISOString().split("T")[0], message: 'Please select past or present date' }
                                    })}
                                    error={!!errorsPay?.paymentDate}
                                    helperText={errorsPay?.paymentDate?.message}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    fullWidth
                                    label={
                                        <Typography className="text-dark">
                                            Amount <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                    }
                                    inputProps={{
                                        min: 0
                                    }}
                                    {...registerPay("amount", {
                                        required: 'Please enter amount to pay',
                                        pattern: {
                                            value: /^\d+(\.\d{1,2})?$/,
                                            message: 'Amount must be a valid number (up to 2 decimal places)'
                                        },
                                        min: { value: 1, message: 'Amount must be a postive number' },
                                        validate: (v) => {
                                            if (watchPay('payType').toString() === '1' && watchPay("balance") && (Number(watchPay("balance").split("₹")[1]) < Number(v))) {
                                                return `Please enter an amount less than the available balance (${watchPay("balance")})`
                                            }
                                            return true
                                        }
                                    })}
                                    error={!!errorsPay.amount}
                                    helperText={errorsPay?.amount?.message}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={4}
                                    id="startDate"
                                    label={
                                        <Typography className="text-dark">
                                            Description <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                    }
                                    variant="outlined"
                                    type="date"
                                    {...registerPay("description", {
                                        required: "Please Enter a description",
                                        validate: (v) => {
                                            if (v.trim().length < 1) {
                                                return 'Empty Values are not allowed'
                                            }
                                            return true
                                        },
                                        maxLength: { value: 150, message: 'Please enter a description less than 150 letters' }
                                    })}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" sx={{ top: "100%" }}>
                                                <p className="menus-green-color"> {150 - (watchPay('description') ? watchPay('description').length : 0)}/150</p>
                                            </InputAdornment>
                                        ),
                                    }}
                                    error={!!errorsPay?.description}
                                    helperText={errorsPay?.description?.message}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-center align-items-center flex-column">
                                <div>Balance available for this chapter: <p className="text-danger">{watchPay('balance') ? watchPay('balance') : '----'}</p></div>
                            </Grid>
                        </Grid>
                        {(watchPay('payType') && watchPay('payType').toString() === '1' && (watchPay('balance') && Number(watchPay('balance').split('₹')[1]) <= 0)) && <p className="text-justify"><span className="text-danger">*</span>Payments are not allowed for this chapter as the outstanding balance is zero or less.</p>}
                        <div className="d-flex gap-3 justify-content-center mt-3 pb-3">
                            <Button
                                variant="outlined"
                                color="error"
                                className="rounded-0"
                                onClick={handleFormClose}>
                                cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="menus-color"
                                type="submit"
                                disabled={watchPay('payType') && watchPay('payType').toString() === '1' && watchPay('balance') && (Number(watchPay('balance').split('₹')[1]) <= 0)}>
                                Pay
                            </Button>
                        </div>
                    </form>
                </Box>
            </Modal>
        </>
    );
};

export default ChapterFinancialReport;